export var ConditionType;
(function (ConditionType) {
    // 不等于
    ConditionType[ConditionType["NotEqual"] = 0] = "NotEqual";
    // 等于
    ConditionType[ConditionType["Equal"] = 1] = "Equal";
    // 大于
    ConditionType[ConditionType["GreaterThan"] = 2] = "GreaterThan";
    // 大于等于
    ConditionType[ConditionType["GreaterThanEqual"] = 3] = "GreaterThanEqual";
    // 小于
    ConditionType[ConditionType["LessThan"] = 4] = "LessThan";
    // 小于等于
    ConditionType[ConditionType["LessThanEqual"] = 5] = "LessThanEqual";
})(ConditionType || (ConditionType = {}));
